module.exports = __webpack_public_path__ + "img/estacionamiento-visita.eef6ec67.svg";